import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { queryClient as qc, querySetting } from 'keys/queryClient'
import { getAssignedCategoriesFetch } from 'store/middlewares/assessment.crud'
import { secretStorage } from 'config'
import { affiliationGroups } from 'keys'
import { foundationCategories, fluencyCategories, gradeNameToLetter, sortGradeLetters, formatGradesLabel } from '../constants'

// שקף "מה נבדק" — קטגוריות ושכבות אמיתיות מתוך הסוללות שהוקצו,
// באותו היקף בדיוק כמו עמוד "מי נמדד" (הרשאות המשתמש + קבוצת בתי ספר + הסמסטר הנוכחי)
const useSlide3Data = (assessmentFilters) => {
    const semesterAndYear = assessmentFilters?.semester_and_year
    const { roleIndex } = useSelector(state => state.user)

    const schoolsGroup = useMemo(() => {
        const { user_data } = secretStorage.getItem("user") || {}
        const { affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
        return affiliation_groups?.find(group => group.name === affiliationGroups.schools)
    }, [roleIndex])

    const { data, isLoading, isError } = useQuery({
        queryKey: [qc.assignedCategories, schoolsGroup?.id, semesterAndYear],
        queryFn: async ({ signal }) => {
            const filters = { ...(schoolsGroup ? { group: schoolsGroup } : {}), semester_and_year: semesterAndYear }
            const { data } = await getAssignedCategoriesFetch(filters, signal)
            return data
        },
        ...querySetting
    })

    return useMemo(() => {
        // { שם קטגוריה בבקנד: [שמות שכבות] }
        const gradesByCategory = {}
        data?.forEach?.(({ category, grades }) => { gradesByCategory[category] = grades || [] })

        // כרטיס עיצובי מאגד כמה קטגוריות בקנד — מוצג רק אם הוקצתה לפחות אחת מהן
        const buildCards = (cards) => cards
            .filter(card => card.categoryNames.some(name => gradesByCategory[name]?.length))
            .map(card => {
                const letters = new Set()
                card.categoryNames.forEach(name =>
                    gradesByCategory[name]?.forEach(gradeName => letters.add(gradeNameToLetter(gradeName))))
                return { ...card, grades: formatGradesLabel(sortGradeLetters([...letters])) }
            })

        return {
            foundationCategories: buildCards(foundationCategories),
            fluencyCategories: buildCards(fluencyCategories),
            isLoading,
            isError
        }
    }, [data, isLoading, isError])
}

export default useSlide3Data
